import { render, staticRenderFns } from "./KEBuySection.vue?vue&type=template&id=6b5d6506&scoped=true&"
import script from "./KEBuySection.vue?vue&type=script&lang=ts&"
export * from "./KEBuySection.vue?vue&type=script&lang=ts&"
import style0 from "./KEBuySection.vue?vue&type=style&index=0&id=6b5d6506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d6506",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsDivider: require('/var/www/packages/theme/components/atoms/Divider.vue').default,MoleculesProductVariations: require('/var/www/packages/theme/components/molecules/ProductVariations.vue').default,AtomsPrice: require('/var/www/packages/theme/components/atoms/Price.vue').default,AtomsKELabel: require('/var/www/packages/theme/components/atoms/KELabel.vue').default,MoleculesPDPCarePlan: require('/var/www/packages/theme/components/molecules/PDPCarePlan.vue').default,MoleculesAvailability: require('/var/www/packages/theme/components/molecules/Availability.vue').default,AtomsAddToCartButton: require('/var/www/packages/theme/components/atoms/AddToCartButton.vue').default,WrappersProductAddToCartText: require('/var/www/packages/theme/components/wrappers/ProductAddToCartText.vue').default,AtomsFavoriteButton: require('/var/www/packages/theme/components/atoms/FavoriteButton.vue').default,MoleculesBuySectionDelivery: require('/var/www/packages/theme/components/molecules/BuySectionDelivery.vue').default,MoleculesBuySectionUsps: require('/var/www/packages/theme/components/molecules/BuySectionUsps.vue').default})
